import React from 'react'

const Footer = (): JSX.Element => {
  return (
    <footer className="footer position-absolute">
      <div className="row g-0 justify-content-between align-items-center h-100">
        <div className="col-12 col-sm-auto text-center">
          <p className="mb-0 mt-2 mt-sm-0 text-900">
            <span className="d-none d-sm-inline-block"></span>
            <span className="d-none d-sm-inline-block mx-1">&nbsp;</span>
            <br className="d-sm-none" />
            2024 &copy;
            <a className="mx-1" href="https://www.lotusrise.org/">
              Lotus Rise
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
